/**
 * Fetches something as text from a URL
 * @param url - The URL to fetch text from
 */
export function getText(url: string): Promise<string> {
  return new Promise((resolve, reject) => {
    if (!url || typeof url !== 'string') {
      reject(new Error('Invalid URL: URL must be a non-empty string'));
      return;
    }

    const xhr = new XMLHttpRequest();

    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4) {
        if (xhr.status >= 200 && xhr.status < 300) {
          resolve(xhr.responseText);
        } else {
          // Handle HTTP errors
          reject(new Error(`HTTP error: ${xhr.status} ${xhr.statusText}`));
        }
      }
    };

    // Handle network errors
    xhr.onerror = function () {
      reject(new Error(`Network error occurred while fetching file from "${url}"`));
    };

    // Handle timeout errors
    xhr.ontimeout = function () {
      reject(new Error(`Request timeout occurred while fetching file from "${url}"`));
    };

    try {
      xhr.open('GET', url, true);
      xhr.setRequestHeader('Content-Type', 'text/plain; charset=UTF-8');
      xhr.setRequestHeader('Accept', 'text/plain');
      xhr.responseType = 'text';
      xhr.timeout = 30000;
      xhr.send();
    } catch (requestError) {
      const errorMessage = requestError instanceof Error ? requestError.message : 'Unknown request error';
      reject(new Error(`Failed to initiate request while fetching file from "${url}": ${errorMessage}`));
    }
  });
}
